<template>
    <div id="userBuyCard">
        <em><span>尊敬的客户，您的买卡申请预计24小时内处理完毕，请耐心等待。</span></em>



        <van-cell-group class="form-input">
            <!-- <van-field
                v-model="recordLoginText"
                required
                label="号码：" 
                readonly
            /> -->

            <van-field
                v-model="userInfo.takeNickname"
                required
                clearable
                label="收件人姓名："
                placeholder="请输入您的姓名"
            />

            <van-field
                v-model="userInfo.takePhone"
                required
                clearable
                name="phoneValidator"
                label="手机号码："
                placeholder="请输入您的手机号码" 
            />

            <van-field
                v-model="userInfo.pcaAddress"
                required
                clearable
                label="地区："
                placeholder="请选择地区"
                readonly
                @click="showAddressVisible()"
            />

            <van-field
                v-model="userInfo.takeAddress"
                required
                clearable
                label="详细地址："
                placeholder="请输入您的详细地址"
            />

            <!-- <van-field
                v-model="userInfo.changeCmccSimName"
                required
                clearable
                label="卡类型："
                placeholder="请选择卡类型"
                readonly
                @click="showPopupVisible()"
            /> -->
            <!-- <p class="tip">{{tips}}</p> -->

            <van-field name="stepper" label="数量" required>
              <template #input>
                <van-stepper v-model="userInfo.iccidSize" @change="onChange"/>
              </template>
            </van-field>

            <van-field
                v-model="userInfo.price"
                required
                label="价格："
                readonly
            />

        </van-cell-group>



        <!--  地区选择  -->
        <van-popup v-model="addressVisible"  position="bottom">
            <van-area
              :area-list="areaList"
              :columns-placeholder="['请选择', '请选择', '请选择']"
              @cancel="cancelSelectAddress()"
              @confirm="selectAddress"
            />
        </van-popup>

        <!-- 卡类型选择 -->
        <van-popup v-model="popupVisible" position="bottom">
            <van-picker
              show-toolbar
              :columns="slots"
              :default-index="defaultIndex"
              @cancel="popupVisible = !popupVisible"
              @confirm="selectValue"
            />
        </van-popup>


        <div class="btnOuter" style="display:flex;">
            <van-button type="primary" size="large" style="background-color:#62B7FA" @click="payCost()">支付费用</van-button>
            <!-- <van-button type="primary" size="large" style="background-color:#62B7FA" @click="toselect()">查看快递信息</van-button> -->
        </div>
        <div style="color: #f76161;margin: 15px 15px 0 15px;line-height: 24px;">
            <p>注意：云南，新疆，西藏，广西宾阳为管制区域，暂不发货，避免浪费您的时间，请上述地区的亲们不要申请，谢谢！</p>
        </div>
    </div>
</template>
<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';

import { wxRequest} from '@/api/user.js' 
import myaddress from '@/utils/pca.json'
import areaListData from '@/utils/Area.js'
import rechargeDetailVue from './rechargeDetail.vue';

export default {
    name: 'userBuyCard',
    data(){
        return {
            userInfo: {
                oldIccid: this.$store.state.iccid,
                takeNickname: '',
                takePhone: '',
                pcaAddress: '',
                takeAddress: '',
                disposeState: '',
                disposeRemark: '',
                changeCmccSim: 4,
                changeCmccSimName: '任意卡',
                equipment:'',
                perprice: '',
                price: '',
                iccidSize: 1,
                agentId:'',
                wxCode:''
            },
             slots: ['电信卡', '任意卡'],
            //slots: [],
            defaultIndex: 1,
            popupVisible: false, //选择卡窗口

            addressVisible: false,  //选择地址窗口
            areaList: areaListData,  //选择地址列表
            addressTmp: '',

            tips:'温馨提醒：电信卡充足，其他卡暂时缺货。',
            recordLoginText: localStorage.getItem('recordLoginText')
        }
    },
    methods: {
        payCost(){
            if(this.userInfo.takeNickname == '' || this.userInfo.takePhone == '' || this.userInfo.takeAddress == '' || this.userInfo.pcaAddress == '' || this.userInfo.changeCmccSimName == ''){
                Dialog.alert({title: '提示', message:'请确保信息完整正确'});
                return;
            }
            if(this.userInfo.takePhone && !(/^[1][3,4,5,7,8][0-9]{9}$/.test(this.userInfo.takePhone))){
                Dialog.alert({title: '提示', message:'请填写正确的手机号'});
                return;
            }
            let data = JSON.parse(JSON.stringify(this.userInfo)); 
            const formData = new FormData();
            Object.keys(data).forEach((key) => {
              formData.append(key, data[key]);
            });
            formData.append("isAgent",0);
            formData.append("changeCmccSim",4);
            wxRequest("order/buy/sim/agent", formData, "post").then(res => {         
                if(res.data.code == 200){
                     let param = res.data.data.param;        
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', param,
                    function(res){
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){
                            if(_this.realName == '1'){
                                window.location.reload();
                            }else {
                                _this.$router.push({
                                    path:'/user/buyAgentCard'
                                });
                            }
                        } 
                    }
                );
                }else{
                     Dialog.alert({title: '提示', message: res.data.message});
                }
            })
        },

        /**选择卡类型 */
        showPopupVisible(){
            this.popupVisible = true;
        },

        selectValue(value, index){
            this.userInfo.changeCmccSimName = value
            this.userInfo.changeCmccSim = value == '电信卡' ? 1 : value == '移动卡' ? 2 : value == '联通卡' ? 3 : 4;
            this.popupVisible = false;
        },
        /**选择卡类型结束 */

        /**选择地址 */
        showAddressVisible(){
            this.addressVisible = true;
        },

        cancelSelectAddress(){
            this.addressTmp = '';
            this.userInfo.pcaAddress = '';
            this.addressVisible = false;
        },
   
        selectAddress(values){
            if(!values[0].code || values[0].code.length<1){
                Toast.fail('请选择地区');
                return ;
            }

            if(!values[1].code || values[1].code.length<1){
                Toast.fail('请选择地区');
                return ;
            }

            if(!values[2].code || values[2].code.length<1){
                Toast.fail('请选择地区');
                return ;
            }

            if(values[0].code == '110000' || values[0].code == '120000' || 
                values[0].code == '310000' || values[0].code == '500000'){
                this.addressTmp = values[0].name + values[2].name
            }else{
                this.addressTmp = values[0].name + values[1].name + values[2].name
            }   

            this.userInfo.pcaAddress = this.addressTmp;
            this.addressVisible = false;
        },
        /**选择地址结束 */
//获取url参数
        getQueryVariable(variable){
           var query = window.location.search.substring(1);
           var vars = query.split("&");
           for (var i=0;i<vars.length;i++) {
                   var pair = vars[i].split("=");
                   if(pair[0] == variable){return pair[1];}
           }
           return false;
        },
        toselect(){
           this.$router.push({
          path: "/user/selectBindPhone",
        });
        },
        //获取价格
        getPrice(){
          let data = {
            agentId: this.userInfo.agentId
          }
          wxRequest('applyChangeSim/buy/agent/price', data, 'post').then(res => {
            if(res.data.code == 200){
              this.userInfo.perprice = res.data.data.price/100;
              this.userInfo.price = this.userInfo.iccidSize * this.userInfo.perprice
              let result = res.data.data.changeSimType;
              let arr = result.split(',');
            //   for (let i = 0 ; i < arr.length ; i++) {
            //       if (arr[i] == '1') {
            //           let telecom = '电信卡';
            //           if(this.slots.indexOf(telecom) < 0) {
            //               this.slots.push(telecom);
            //           }
            //       }
            //       else if (arr[i] == '2') {
            //           let mobile = '移动卡';
            //           if(this.slots.indexOf(mobile) < 0) {
            //               this.slots.push(mobile);
            //           }
            //       }
            //       else if (arr[i] == '3') {
            //           let randomCard = '联通卡';
            //           if(this.slots.indexOf(randomCard) < 0) {
            //               this.slots.push(randomCard);
            //           }
            //       }
            //   }
              if (res.data.data.changeSimType == 2) {
                  this.slots = ['移动卡'];
              }
              else if(res.data.data.changeSimType == 1) {
                  this.slots = ['电信卡'];
              }
              else if(res.data.data.changeSimType == 3){
                  this.slots = ['任意卡'];
              }
            }
          })
        },
        //步进器改变执行
        onChange(val){
          this.userInfo.iccidSize = val;
          this.userInfo.price = this.userInfo.iccidSize * this.userInfo.perprice
        }
    },
    created(){
         var source = this.getQueryVariable('source') ? this.getQueryVariable('source') : process.env.VUE_APP_APPID;
        localStorage.setItem('appid', source);
        localStorage.setItem('isHeadquarterAppid', false);
        var appid  = source ? source : process.env.VUE_APP_APPID;
        console.log(appid)
        var redirectUrl = window.location.href;   
        var index = redirectUrl.indexOf('code');
        redirectUrl = encodeURIComponent(redirectUrl);
        if(index < 0){
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`
        }else{
            var search = window.location.search;
            var startIndex = search.indexOf('code');
            var endIndex = search.indexOf('&', startIndex);
            var str = search.slice(startIndex, endIndex);
            var code = str.slice(str.indexOf('=') + 1);
            this.userInfo.wxCode = code;
        }
        this.userInfo.agentId= this.$route.query.agentId;
        this.getPrice();
        console.log(this.userInfo.agentId)
    }
}
</script>
<style lang="less" scoped>
#userBuyCard {
    em {
        display: block;
        background: #26a2ff;
        color: #fff;
        padding: 10px;
        line-height: 1.5em;
    }

    .btnOuter {
        margin: 10px 0 20px;
        padding: 15px 5% 0;
        .van-button{
            border: 1px solid #f7f8fa;
            margin-right: 5px;
            margin-left: 5px;
            height: 40px;
            border-radius: 5px;
        }
    }

    .changImg {
        padding: 0 8%;
        img {
            width: 100%;
            height: 100%;
            padding: 20px 0 0 0;
        }
    }


    .form-input{
        .tip{
            padding: 2px 10px;
        }
    }

    .tip{
        color: red;
        line-height: 16px;
        font-size: 12px;
    }
}
</style>

<style>
#userBuyCard .form-input .van-field__control{
    line-height: 24px;
}
</style>